import type { DeskRow, SessionInfo } from "@/api/types";

interface DeskBottomBarProps {
  desk: DeskRow;
  sessions: SessionInfo[] | undefined;
  relayReachable: boolean | null;
  activeWork: boolean;
}

export function DeskBottomBar({
  desk,
  sessions,
  relayReachable,
  activeWork,
}: DeskBottomBarProps) {
  const sessionCount = sessions?.length ?? 0;
  const runningCount =
    sessions?.filter(
      (s) => s.agentStatus === "running" || s.agentStatus === "starting",
    ).length ?? 0;

  return (
    <div
      className="hidden md:flex items-center gap-4 px-4 py-1.5 border-t text-[11px]"
      style={{
        borderColor: "var(--blt)",
        background: "var(--surface)",
        color: "var(--t4)",
        fontFamily: "var(--font-mono)",
        flexShrink: 0,
      }}
    >
      <span>{desk.sprite_name}</span>

      {relayReachable !== null && (
        <span
          style={{
            color: relayReachable ? "var(--t4)" : "var(--err)",
          }}
        >
          {relayReachable ? "· relay ok" : "· relay unreachable"}
        </span>
      )}

      {activeWork && (
        <span
          className="flex items-center gap-1"
          style={{ color: "var(--accent)" }}
        >
          <span
            className="w-1.5 h-1.5 rounded-full"
            style={{
              background: "var(--accent)",
              animation: "pulse 1.5s ease-in-out infinite",
            }}
          />
          agent working
        </span>
      )}

      {sessionCount > 0 && (
        <span>
          {sessionCount} session{sessionCount !== 1 ? "s" : ""}
          {runningCount > 0 && ` · ${runningCount} running`}
        </span>
      )}
    </div>
  );
}
